import { useState, useEffect } from "react";
import AppLogo from '../components/AppLogo';


const DISCOVERY_API = "https://liveapi.clawappz.com/api/businesses/discovery";

const DUMMY_BUSINESSES = [
  {
    id: "d1", name: "Jollof House", businessType: "Restaurant",
    description: "Authentic West African cuisine with wood-fired jollof rice and fresh tilapia.",
    location: "Osu, Accra", logo: "", storeUrl: "jollofhouse", category: "Food & Dining",
    rating: 4.9, teamSize: "12", yearsActive: "3", badge: "trending", heroColor: "#1a0a00", accentColor: "#FF6B2C",
    productImages: ["https://images.unsplash.com/photo-1567360425618-1594206637d2?w=800&q=80"],
  },
  {
    id: "d2", name: "TechHub Ghana", businessType: "Co-working",
    description: "Premium workspace for builders, founders, and remote teams.",
    location: "Airport City, Accra", logo: "", storeUrl: "techhubghana", category: "Workspace",
    rating: 4.7, teamSize: "8", yearsActive: "5", badge: "featured", heroColor: "#000d1a", accentColor: "#2C8DFF",
    productImages: ["https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80"],
  },
  {
    id: "d3", name: "Kente & Co.", businessType: "Fashion",
    description: "Contemporary Ghanaian fashion — traditional kente reimagined for modern wear.",
    location: "Kumasi", logo: "", storeUrl: "kenteandco", category: "Fashion",
    rating: 4.8, teamSize: "6", yearsActive: "2", badge: "new", heroColor: "#1a0d00", accentColor: "#FFB020",
    productImages: ["https://images.unsplash.com/photo-1590735213920-68192a487bc2?w=800&q=80"],
  },
  {
    id: "d4", name: "Accra Rides", businessType: "Transport",
    description: "On-demand rides and deliveries across Greater Accra.",
    location: "Accra Metro", logo: "", storeUrl: "accrarides", category: "Transport",
    rating: 4.6, teamSize: "45", yearsActive: "4", badge: "popular", heroColor: "#00100d", accentColor: "#00C896",
    productImages: ["https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80"],
  },
  {
    id: "d5", name: "Nana Beauty", businessType: "Wellness",
    description: "Natural skincare and salon services using indigenous African botanicals.",
    location: "East Legon, Accra", logo: "", storeUrl: "nanabeauty", category: "Beauty",
    rating: 5.0, teamSize: "9", yearsActive: "2", badge: "featured", heroColor: "#1a0010", accentColor: "#FF2C8D",
    productImages: ["https://images.unsplash.com/photo-1619451050621-83cb7aada2d7?w=800&q=80"],
  },
  {
    id: "d6", name: "Claw", businessType: "Technology",
    description: "The platform powering modern Ghanaian commerce. Build, launch, grow.",
    location: "Accra, Ghana", logo: "https://weyyfslmfqjlkvtfwunm.supabase.co/storage/v1/object/public/Claw/logos/1777197896050-60a4a90cd7614fbfbfb9220c37d0b817.png",
    storeUrl: "claw", category: "Platform", rating: 4.9, teamSize: "20", yearsActive: "3", badge: "featured", heroColor: "#0d0005", accentColor: "#FF6B2C",
    productImages: ["https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80"],
  },
  {
    id: "d7", name: "Gold Coast Eats", businessType: "Restaurant",
    description: "Fine dining meets street food culture in the heart of Accra.",
    location: "Labone, Accra", logo: "", storeUrl: "goldcoasteats", category: "Food & Dining",
    rating: 4.8, badge: "trending", heroColor: "#0d0800", accentColor: "#FFAA00",
    productImages: ["https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80"],
  },
  {
    id: "d8", name: "Volta Fitness", businessType: "Fitness",
    description: "State-of-the-art gym and personal training for serious athletes.",
    location: "Cantonments, Accra", logo: "", storeUrl: "voltafitness", category: "Fitness",
    rating: 4.7, badge: "popular", heroColor: "#000a10", accentColor: "#00AAFF",
    productImages: ["https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80"],
  },
];

const CATEGORIES = ["All", "Food & Dining", "Fashion", "Workspace", "Beauty", "Transport", "Fitness", "Technology"];

const getSlug = (b) => {
  const raw = b.storeUrl || b.store_url || b.id || "";
  return raw.toString().trim().replace(/https?:\/\//i, "").split("/").filter(Boolean).pop() || raw;
};

const StarRating = ({ rating, accent }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
    <span style={{ color: accent || "#FF6B2C", fontSize: "12px" }}>★</span>
    <span style={{ fontSize: "12px", fontWeight: 600, color: "#fff" }}>{rating}</span>
  </div>
);

const Badge = ({ type }) => {
  const config = {
    featured: { color: "#FF6B2C" },
    trending: { color: "#FFAA00" },
    new: { color: "#00C896" },
    popular: { color: "#2C8DFF" },
  };
  const c = config[type] || config.featured;
  return (
    <span style={{
      fontSize: "10px", fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase",
      color: c.color,
    }}>
      • {type}
    </span>
  );
};

const LogoMark = ({ business, size = 40 }) => {
  const url = business.logo || business.brandImage || "";
  const init = (business.name || "?")[0].toUpperCase();
  const accent = business.accentColor || "#FF6B2C";
  return (
    <div style={{
      width: size, height: size, borderRadius: Math.round(size * 0.28),
      background: url ? "transparent" : "#1A1A1A",
      overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0,
      fontSize: size * 0.38, fontWeight: 800, color: accent,
      fontFamily: "'Roboto Condensed', sans-serif",
    }}>
      {url ? <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : init}
    </div>
  );
};

const useHover = () => {
  const [hovered, setHovered] = useState(false);
  return [hovered, { onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) }];
};

/* ── CARD 0: Hero Full-Width ── */
const HeroCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const img = b.productImages?.[0] || "";
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} className="col-span-full" style={{ textDecoration: "none", display: "block" }} {...handlers}>
      <div style={{
        position: "relative", borderRadius: 24, overflow: "hidden", height: 480,
        background: b.heroColor || "#0B0B0B",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.4s ease, box-shadow 0.4s ease",
        boxShadow: hovered ? "0 24px 60px rgba(0,0,0,0.8)" : "0 8px 32px rgba(0,0,0,0.4)",
      }}>
        {img && (
          <div style={{
            position: "absolute", inset: 0,
            backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center",
            transform: hovered ? "scale(1.05)" : "scale(1)",
            transition: "transform 0.6s ease",
          }} />
        )}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(120deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 60%, rgba(0,0,0,0.0) 100%)",
        }} />
        <div className="hero-content" style={{ position: "relative", zIndex: 2, padding: 48, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
            <LogoMark business={b} size={52} />
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              {b.badge && <Badge type={b.badge} />}
              {b.category && (
                <span style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: "#fff" }}>
                  {b.category}
                </span>
              )}
            </div>
          </div>
          <div>
            <h2 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 56, fontWeight: 900, color: "#fff", lineHeight: 0.95, letterSpacing: "-0.02em", marginBottom: 12 }}>
              {b.name}
            </h2>
            <p style={{ fontSize: 15, color: "rgba(255,255,255,0.65)", maxWidth: 480, lineHeight: 1.55, marginBottom: 24 }}>
              {b.description}
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{
                display: "inline-flex", alignItems: "center", gap: 8, padding: "12px 24px",
                background: accent, color: "#111", borderRadius: 12,
                fontSize: 12, fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase",
                transform: hovered ? "translateX(4px)" : "translateX(0)",
                transition: "transform 0.3s",
              }}>
                Visit store <span>→</span>
              </div>
              {b.location && (
                <span style={{ fontSize: 13, color: "rgba(255,255,255,0.5)" }}>
                  ◎ {b.location}
                </span>
              )}
              {b.rating && <StarRating rating={b.rating} accent={accent} />}
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

/* ── CARD 1: Tall Portrait ── */
const TallCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const img = b.productImages?.[0] || "";
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} style={{ textDecoration: "none", display: "block" }} {...handlers}>
      <div style={{
        position: "relative", borderRadius: 24, overflow: "hidden", height: 520,
        background: b.heroColor || "#111",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.35s ease, box-shadow 0.35s",
        boxShadow: hovered ? "0 24px 60px rgba(0,0,0,0.8)" : "0 4px 20px rgba(0,0,0,0.4)",
      }}>
        {img && (
          <div style={{
            position: "absolute", inset: 0,
            backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center",
            transform: hovered ? "scale(1.05)" : "scale(1)",
            transition: "transform 0.5s ease",
          }} />
        )}
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.2) 60%, transparent 100%)" }} />
        <div style={{ position: "absolute", top: 20, left: 20, right: 20, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <LogoMark business={b} size={40} />
          {b.badge && <Badge type={b.badge} />}
        </div>
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: 24 }}>
          {b.category && <p style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.24em", textTransform: "uppercase", color: accent, marginBottom: 8 }}>{b.category}</p>}
          <h3 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 26, fontWeight: 900, color: "#fff", lineHeight: 1.1, marginBottom: 6 }}>{b.name}</h3>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            {b.location && <span style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>◎ {b.location}</span>}
            {b.rating && <StarRating rating={b.rating} accent={accent} />}
          </div>
        </div>
      </div>
    </a>
  );
};

/* ── CARD 2: Wide Landscape ── */
const LandscapeCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const img = b.productImages?.[0] || "";
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} className="col-span-2" style={{ textDecoration: "none", display: "block" }} {...handlers}>
      <div className="card-landscape" style={{
        position: "relative", borderRadius: 24, overflow: "hidden", height: "100%", minHeight: 280,
        background: b.heroColor || "#111",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.3s ease, box-shadow 0.3s",
        boxShadow: hovered ? "0 20px 50px rgba(0,0,0,0.8)" : "0 4px 20px rgba(0,0,0,0.4)",
        display: "grid", gridTemplateColumns: "1fr 1fr",
      }}>
        <div className="landscape-img" style={{
          backgroundImage: img ? `url(${img})` : "none",
          backgroundSize: "cover", backgroundPosition: "center",
          transform: hovered ? "scale(1.03)" : "scale(1)",
          transition: "transform 0.5s ease",
        }} />
        <div style={{ background: b.heroColor || "#111", padding: 32, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <LogoMark business={b} size={44} />
            {b.badge && <Badge type={b.badge} />}
          </div>
          <div style={{ marginTop: 24 }}>
            {b.category && <p style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.24em", textTransform: "uppercase", color: accent, marginBottom: 8 }}>{b.category}</p>}
            <h3 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 28, fontWeight: 900, color: "#fff", lineHeight: 1.1, marginBottom: 8 }}>{b.name}</h3>
            <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", lineHeight: 1.55, marginBottom: 16 }}>{b.description}</p>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              {b.rating && <StarRating rating={b.rating} accent={accent} />}
              <div style={{
                fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
                color: accent, borderRadius: 12,
                transform: hovered ? "translateX(4px)" : "translateX(0)", transition: "transform 0.25s",
              }}>Visit →</div>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

/* ── CARD 3: Flat Dark Card ── */
const FlatCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const img = b.productImages?.[0] || "";
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} style={{ textDecoration: "none", display: "block" }} {...handlers}>
      <div style={{
        position: "relative", borderRadius: 24, overflow: "hidden", height: 340,
        background: "#161616",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.35s ease, box-shadow 0.35s ease",
        boxShadow: hovered ? "0 16px 40px rgba(0,0,0,0.6)" : "0 4px 16px rgba(0,0,0,0.3)",
      }}>
        {img && (
          <div style={{
            position: "absolute", inset: 0, height: "50%",
            backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center",
            filter: "brightness(0.6)",
          }} />
        )}
        <div style={{
          position: "absolute", inset: 0, top: img ? "50%" : 0,
          background: "#161616", padding: 24,
          display: "flex", flexDirection: "column", justifyContent: "space-between",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: img ? -44 : 0 }}>
            <LogoMark business={b} size={44} />
            {b.badge && <div style={{ marginTop: img ? 44 : 0 }}><Badge type={b.badge} /></div>}
          </div>
          <div style={{ marginTop: 16 }}>
            {b.category && <p style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.24em", textTransform: "uppercase", color: accent, marginBottom: 8 }}>{b.category}</p>}
            <h3 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 24, fontWeight: 900, color: "#fff", lineHeight: 1.15, marginBottom: 8 }}>{b.name}</h3>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {b.rating && <StarRating rating={b.rating} accent={accent} />}
                {b.location && <span style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>· {b.location}</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

/* ── CARD 4: Square Overlay ── */
const SquareCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const img = b.productImages?.[0] || "";
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} style={{ textDecoration: "none", display: "block" }} {...handlers}>
      <div style={{
        position: "relative", borderRadius: 24, overflow: "hidden",
        aspectRatio: "1 / 1", background: b.heroColor || "#111",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.35s ease, box-shadow 0.3s",
        boxShadow: hovered ? "0 20px 50px rgba(0,0,0,0.8)" : "0 4px 20px rgba(0,0,0,0.4)",
      }}>
        {img && (
          <div style={{
            position: "absolute", inset: 0,
            backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center",
            transform: hovered ? "scale(1.05)" : "scale(1)",
            transition: "transform 0.6s ease",
          }} />
        )}
        <div style={{ position: "absolute", inset: 0, background: `linear-gradient(to top, ${b.heroColor || "#000"} 0%, transparent 60%)` }} />
        <div style={{ position: "absolute", top: 16, left: 16, right: 16, display: "flex", justifyContent: "space-between" }}>
          {b.badge && <Badge type={b.badge} />}
          {b.rating && (
            <div style={{ background: "#111", padding: "4px 10px", borderRadius: 4, display: "flex", alignItems: "center", gap: 4 }}>
              <StarRating rating={b.rating} accent={accent} />
            </div>
          )}
        </div>
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: 20 }}>
          <p style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase", color: accent, marginBottom: 6 }}>{b.category}</p>
          <h3 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 22, fontWeight: 900, color: "#fff", lineHeight: 1.1 }}>{b.name}</h3>
          <p style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", marginTop: 4 }}>◎ {b.location}</p>
        </div>
      </div>
    </a>
  );
};

/* ── CARD 5: Minimal Dark ── */
const MinimalCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} style={{ textDecoration: "none", display: "block" }} {...handlers}>
      <div style={{
        borderRadius: 24, overflow: "hidden", padding: 28, height: "100%",
        background: hovered ? "#1a1a1a" : "#111111",
        transition: "background 0.25s, box-shadow 0.25s",
        boxShadow: hovered ? "0 16px 40px rgba(0,0,0,0.6)" : "none",
        display: "flex", flexDirection: "column"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
          <LogoMark business={b} size={48} />
          {b.badge && <Badge type={b.badge} />}
        </div>
        <p style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.24em", textTransform: "uppercase", color: accent, marginBottom: 8 }}>{b.category}</p>
        <h3 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 22, fontWeight: 900, color: "#fff", lineHeight: 1.15, marginBottom: 10 }}>{b.name}</h3>
        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", lineHeight: 1.6, marginBottom: 20, flex: 1 }}>{b.description}</p>
        <div style={{ height: "1px", background: "rgba(255,255,255,0.07)", marginBottom: 20 }} />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            {b.location && <p style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 3 }}>◎ {b.location}</p>}
            {b.rating && <StarRating rating={b.rating} accent={accent} />}
          </div>
          <div style={{
            fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase",
            color: accent, display: "flex", alignItems: "center", gap: 6,
            transform: hovered ? "translateX(4px)" : "translateX(0)", transition: "transform 0.25s",
          }}>Open store →</div>
        </div>
      </div>
    </a>
  );
};

/* ── CARD 6: Floating Content ── */
const FloatingCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const img = b.productImages?.[0] || "";
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} className="col-span-2" style={{ textDecoration: "none", display: "block" }} {...handlers}>
      <div style={{ position: "relative", height: 360, borderRadius: 24, overflow: "hidden",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.3s ease, box-shadow 0.3s",
        boxShadow: hovered ? "0 24px 60px rgba(0,0,0,0.8)" : "0 8px 32px rgba(0,0,0,0.4)",
      }}>
        {img && (
          <div style={{
            position: "absolute", inset: 0,
            backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center",
            filter: "brightness(0.5)",
            transform: hovered ? "scale(1.03)" : "scale(1)",
            transition: "transform 0.6s ease",
          }} />
        )}
        <div style={{ position: "absolute", inset: 0, background: `linear-gradient(135deg, ${b.heroColor || "#000"}f2 0%, transparent 80%)` }} />
        <div className="floating-content" style={{ position: "absolute", top: 28, left: 28, right: 28, bottom: 28 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
            <div>
              {b.category && <p style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.28em", textTransform: "uppercase", color: accent, marginBottom: 10 }}>{b.category}</p>}
              <h3 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 42, fontWeight: 900, color: "#fff", lineHeight: 0.95, letterSpacing: "-0.02em" }}>{b.name}</h3>
            </div>
            <LogoMark business={b} size={52} />
          </div>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.55)", lineHeight: 1.6, maxWidth: 400, marginBottom: 28 }}>{b.description}</p>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 22px",
              background: accent, color: "#111", borderRadius: 12,
              fontSize: 11, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase",
              transform: hovered ? "translateX(4px)" : "translateX(0)", transition: "transform 0.3s",
            }}>
              Explore →
            </div>
            {b.rating && (
              <div style={{ background: "#111", padding: "8px 14px", borderRadius: 8 }}>
                <StarRating rating={b.rating} accent={accent} />
              </div>
            )}
            {b.badge && <Badge type={b.badge} />}
          </div>
        </div>
      </div>
    </a>
  );
};

/* ── CARD 7: Compact Row ── */
const CompactCard = ({ b }) => {
  const [hovered, handlers] = useHover();
  const href = `/${getSlug(b)}`;
  const img = b.productImages?.[0] || "";
  const accent = b.accentColor || "#FF6B2C";
  return (
    <a href={href} style={{ textDecoration: "none", display: "block", height: "100%" }} {...handlers}>
      <div style={{
        borderRadius: 24, overflow: "hidden", background: "#111", height: "100%",
        transition: "transform 0.3s, box-shadow 0.3s",
        transform: hovered ? "translateY(-3px)" : "translateY(0)",
        boxShadow: hovered ? "0 12px 30px rgba(0,0,0,0.6)" : "none",
        display: "flex", flexDirection: "column"
      }}>
        {img && (
          <div style={{
            height: 160, backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center",
            transform: hovered ? "scale(1.05)" : "scale(1)",
            transition: "transform 0.5s ease",
          }} />
        )}
        <div style={{ padding: "20px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
              <LogoMark business={b} size={32} />
              {b.rating && <StarRating rating={b.rating} accent={accent} />}
            </div>
            <h3 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 18, fontWeight: 700, color: "#fff", lineHeight: 1.1 }}>{b.name}</h3>
            {b.category && <p style={{ fontSize: "10px", color: accent, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginTop: 8 }}>{b.category}</p>}
          </div>
          {b.location && <p style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginTop: 12, marginBottom: 0 }}>◎ {b.location}</p>}
        </div>
      </div>
    </a>
  );
};

const CARD_TEMPLATES = [HeroCard, TallCard, LandscapeCard, FlatCard, SquareCard, MinimalCard, FloatingCard, CompactCard];

const SectionHeader = ({ label, title }) => (
  <div style={{ marginBottom: 28 }}>
    <p style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.3em", textTransform: "uppercase", color: "#FF6B2C", marginBottom: 8 }}>{label}</p>
    <h2 style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: 28, fontWeight: 900, color: "#fff", letterSpacing: "-0.01em" }}>{title}</h2>
  </div>
);

export default function DiscoverPage() {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("All");
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetch(DISCOVERY_API, { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : []))
      .catch(() => [])
      .then((data) => {
        const live = Array.isArray(data) ? data : [];
        const merged = [...live, ...DUMMY_BUSINESSES.slice(0, Math.max(0, 8 - live.length))];
        setBusinesses(merged);
        setLoading(false);
      });
  }, []);

  const filtered = businesses.filter((b) => {
    const matchCat = activeCategory === "All" || b.category === activeCategory;
    const q = search.toLowerCase();
    const matchSearch = !q || b.name?.toLowerCase().includes(q) || b.category?.toLowerCase().includes(q) || b.location?.toLowerCase().includes(q);
    return matchCat && matchSearch;
  });

  const featured = filtered.filter((b) => b.badge === "featured");
  const trending = filtered.filter((b) => b.badge === "trending");

  const renderCard = (b, templateIndex, key) => {
    const Template = CARD_TEMPLATES[templateIndex % CARD_TEMPLATES.length];
    return <Template key={key || b.id} b={b} />;
  };

  return (
    <div style={{ position: "relative", minHeight: "100vh", background: "#0B0B0B", fontFamily: "'Roboto', sans-serif", WebkitFontSmoothing: "antialiased" }}>
      
      {/* Global Responsive Styles */}
      <style>{`
        .nav-container { padding: 0 40px; }
        .hero-container { padding: 56px 40px 0; }
        .main-container { padding: 48px 40px; }
        .grid-container { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
        .col-span-full { grid-column: 1 / -1; }
        .col-span-2 { grid-column: span 2; }
        .hero-header { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 40px; gap: 20px; }
        .search-wrapper { width: 100%; max-width: 320px; }

        .reflective-text {
            position: relative;
            display: inline-block;
            color: #fff;
            /* Create a gradient that spans beyond the text */
            background: linear-gradient(
            90deg, 
            rgba(255,255,255,0.1) 0%, 
            rgba(255,255,255,0.8) 50%, 
            rgba(255,255,255,0.1) 100%
            );
            background-size: 200% 100%;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            /* Animation runs for 3s, repeating every 120s (2 minutes) */
            animation: reflect 120s linear infinite;
        }

        @keyframes reflect {
            0% { background-position: 200% 0; }
            5% { background-position: -200% 0; } /* Animates the shine over 6 seconds (5% of 120s) */
            100% { background-position: -200% 0; } /* Pauses for the remaining 114 seconds */
        } 
                
        @media (max-width: 900px) {
          .grid-container { grid-template-columns: repeat(2, 1fr); }
          .col-span-2 { grid-column: span 2; }
        }
        
        @media (max-width: 768px) {
          .hero-header { flex-direction: column; align-items: flex-start; }
          .search-wrapper { max-width: 100%; }
        }
        
        @media (max-width: 600px) {
          .nav-container { padding: 0 20px; }
          .hero-container { padding: 40px 20px 0; }
          .main-container { padding: 32px 20px; }
          .grid-container { grid-template-columns: 1fr; }
          .col-span-2, .col-span-full { grid-column: 1 / -1; }
          .card-landscape { grid-template-columns: 1fr !important; }
          .landscape-img { height: 200px; }
          .hero-content { padding: 32px !important; }
          .floating-content h3 { font-size: 32px !important; }
        }
      `}</style>

      {/* Ambient Background Glow */}
      <div style={{
        position: "fixed", inset: 0, zIndex: 0, pointerEvents: "none", overflow: "hidden"
      }}>
        <div style={{
          position: "absolute", top: "-10%", left: "-10%", width: "60vw", height: "60vw",
          background: "radial-gradient(circle, rgba(255,107,44,0.06) 0%, transparent 60%)",
          filter: "blur(100px)", borderRadius: "50%"
        }} />
        <div style={{
          position: "absolute", bottom: "-20%", right: "-10%", width: "70vw", height: "70vw",
          background: "radial-gradient(circle, rgba(44,141,255,0.04) 0%, transparent 60%)",
          filter: "blur(120px)", borderRadius: "50%"
        }} />
      </div>

      {/* Nav */}
      <nav className="nav-container" style={{
        position: "sticky", top: 0, zIndex: 50,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        height: 60, borderBottom: "1px solid rgba(255,255,255,0.06)",
        background: "rgba(11,11,11,0.8)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)",
      }}>
        <a href="/" >
          <AppLogo variant="wordmark" size={46} color='#ff4800' shape='none' />
        </a>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <a href="/" style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", textDecoration: "none", padding: "6px 14px" }}>Home</a>
          <a href="/discover" style={{ fontSize: 12, color: "#FF6B2C", textDecoration: "none", fontWeight: 600, padding: "6px 14px" }}>Discover</a>
        </div>
      </nav>

      {/* Hero Banner */}
      <div className="hero-container" style={{ position: "relative", zIndex: 1, borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          
          <div className="hero-header">
            <h1 className="reflective-text" 
                style={{ 
                    fontFamily: "'Roboto Condensed', sans-serif", 
                    fontSize: "clamp(48px, 6vw, 80px)", 
                    fontWeight: 900, 
                    lineHeight: 0.92, 
                    letterSpacing: "-0.03em", 
                    textTransform: "uppercase", 
                    margin: 0 
                }}>
              Discovery
            </h1>

            {/* Search */}
            <div className="search-wrapper">
              <div style={{
                display: "flex", alignItems: "center", gap: 8,
                padding: "6px 12px", borderRadius: 12,
                background: "rgba(22,22,22,0.6)", backdropFilter: "blur(8px)", border: "1px solid rgba(255,255,255,0.08)",
              }}>
                <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 22 }}>⌕</span>
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search businesses..."
                  style={{
                    background: "transparent", border: "none", outline: "none",
                    color: "#fff", fontSize: 15, flex: 1,
                    fontFamily: "'Roboto', sans-serif",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Text-only Categories */}
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap", paddingBottom: 28 }}>
            {CATEGORIES.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                style={{
                  background: "transparent", border: "none", cursor: "pointer", padding: 0,
                  fontSize: "13px", fontWeight: activeCategory === cat ? 700 : 500, letterSpacing: "0.08em",
                  fontFamily: "'Roboto', sans-serif",
                  color: activeCategory === cat ? "#FF6B2C" : "rgba(255,255,255,0.4)",
                  transition: "color 0.2s",
                }}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="main-container" style={{ position: "relative", zIndex: 1, maxWidth: 1200, margin: "0 auto" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "80px 0" }}>
            <div style={{
              width: 36, height: 36, borderRadius: "50%",
              border: "2px solid #1A1A1A", borderTopColor: "#FF6B2C",
              animation: "spin 0.7s linear infinite", margin: "0 auto 16px",
            }} />
            <p style={{ fontSize: 13, color: "rgba(255,255,255,0.3)", letterSpacing: "0.1em" }}>Loading businesses...</p>
            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
          </div>
        ) : (
          <>
            {/* Featured Section */}
            {featured.length > 0 && (
              <section style={{ marginBottom: 60 }}>
                <SectionHeader label="Handpicked" title="Featured businesses" />
                <div className="grid-container">
                  {featured[0] && <HeroCard b={featured[0]} />}
                  {featured.slice(1, 3).map((b) => <TallCard key={b.id} b={b} />)}
                </div>
              </section>
            )}

            {/* Trending Section */}
            {trending.length > 0 && (
              <section style={{ marginBottom: 60 }}>
                <SectionHeader label="Right now" title="Trending" />
                <div className="grid-container">
                  {trending.map((b, i) => {
                    if (i === 0) return <FloatingCard key={b.id} b={b} />;
                    if (i === 1) return <FlatCard key={b.id} b={b} />;
                    return <SquareCard key={b.id} b={b} />;
                  })}
                </div>
              </section>
            )}

            {/* All Businesses */}
            {filtered.length > 0 && (
              <section>
                <SectionHeader label="Directory" title="All businesses" />
                <div className="grid-container">
                  {filtered.map((b, i) => renderCard(b, i + 1, b.id))}
                </div>
              </section>
            )}

            {filtered.length === 0 && !loading && (
              <div style={{ textAlign: "center", padding: "80px 0" }}>
                <p style={{ fontSize: 24, fontWeight: 900, color: "#fff", fontFamily: "'Roboto Condensed', sans-serif", marginBottom: 8 }}>No businesses found</p>
                <p style={{ fontSize: 13, color: "rgba(255,255,255,0.35)" }}>Try a different search or category.</p>
              </div>
            )}
          </>
        )}
      </div>

      {/* Footer */}
      <footer className="nav-container" style={{
        position: "relative", zIndex: 1,
        borderTop: "1px solid rgba(255,255,255,0.06)",
        paddingTop: 28, paddingBottom: 28,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        fontSize: 12, color: "rgba(255,255,255,0.3)",
      }}>
        <span>Claw — Discovery</span>
        <div style={{ display: "flex", gap: 24 }}>
          <a href="/" style={{ color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>Home</a>
        </div>
      </footer>
    </div>
  );
}